import React from "react";
import { render } from "react-dom";
import { AppContainer } from "react-hot-loader";
import Root from "./components/Root";
import "./sass/index.scss";
import "images/upgrad/phoenix-logo-icon-grayscale@2x.png";
import "images/upgrad/3dotsPreloader.gif";
import { store, persistor, history } from "store";

const loader = document.querySelector(".rootPreloader");
const hideRootPreLoader = () => loader.classList.add("rootPreloader--hide");

render(
	<AppContainer>
		<Root
			store={store}
			history={history}
			persistor={persistor}
			hideRootPreLoader={hideRootPreLoader}
		/>
	</AppContainer>,
	document.getElementById("app")
);

if (module.hot) {
	module.hot.accept("./components/Root", () => {
		const NewRoot = require("./components/Root").default;
		render(
			<AppContainer>
				<NewRoot
					store={store}
					history={history}
					persistor={persistor}
				/>
			</AppContainer>,
			document.getElementById("app")
		);
	});
}
